module.exports = __webpack_public_path__ + "static/img/csletf.82f2045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/csletf.png
// module id = Tvb0
// module chunks = 0